var cm_worldwide = function () {
  var _js_jquery = '//ajax.googleapis.com/ajax/libs/jquery/2.2.1/jquery.min.js';
  var _js_autolink = '//cdnjs.cloudflare.com/ajax/libs/autolinker/3.0.5/Autolinker.min.js';
  var _resource = 'https://assets.kef.com/worldwide-contact/staging/worldwide-contact.json';
  return {
    max: 100,
    prepare: function () {
      var that = this;
      if (typeof jQuery !== 'function' && that.max) {
        that.max--;
        that.$();
      }
      else {
        that.init();
      }
    },
    init: function () {
      var that = this;
      $.getScript(_js_autolink, function (data, textStatus, jqxhr) {
        $('.cm_worldwide').each(function () {
          var container = $(this);
          $.getJSON(_resource, function (result) {
            that.process(container, result);
          });
        });
      });
    },
    process: function ($w, list) {
      $w.html('');
      var s = $('<select />');
      for (var i in list) {
        $('<option />').val(i).html(i).appendTo(s);
      }
      s.appendTo($w);
      $('<hr />').appendTo($w);
      var $pool = $('<div />').addClass('pool');
      $pool.appendTo($w);
      var autolinker = new Autolinker({
        newWindow: true, truncate: 0
      });
      s.on('change', function () {
        $pool.html('');
        var current = list[this.value];
        for (var j in current) {
          var card = $('<div />')
            .append($('<b />').addClass('store-title').html(current[j].title));
          if (typeof current[j].left !== 'undefined')
            card.append($('<div />').addClass('store-desc').append(autolinker.link(current[j].left.join('<br />'))));
          if (typeof current[j].right !== 'undefined')
            card.append($('<div />').addClass('store-desc').append(autolinker.link(current[j].right.join('<br />'))));
          card.html(card.html());
          card.appendTo($pool);
        }
      }).trigger('change');
    },
    $: function () {
      var that = this;
      var sNew = document.createElement('script');
      sNew.async = true;
      sNew.src = _js_jquery;
      var s0 = document.getElementsByTagName('script')[0];
      s0.parentNode.insertBefore(sNew, s0);
      setTimeout(function () {
        that.init();
      }, 1);
    }
  };
}();
cm_worldwide.prepare();